import { Table } from "antd";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ExFactoryDate from "../Table/ExFactoryDate/ExFactoryDate";
import Request from "../Table/Request/Request";
import Brand from "../Table/Brand/Brand";
import QtyReqRec from "../Table/QtyReqRec/QtyReqRec";
import DateSentReceive from "../Table/DateSentRec/DateSentRec";
import { useDispatch, useSelector } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";
import {
  getSrtInitialList,
  massSearchFilter,
  selectUnselectSrtTableRows,
  srtEXportArray,
  srtSeasonSearchFilter,
} from "../../../Redux/actions/Srt/Srt";
import { Pagination } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from "../../../UIComponents/Loader";

const SalesTable = ({ current, setCurrent, pageCount, setPageCount,totalPerPage, chunkSize, containerRef  }) => {
  const dispatch = useDispatch();
  let srtDataList = useSelector((state) => state?.Srt?.getSrtDataList);
  const massFilterApiData = useSelector(
    (state) => state?.Srt?.massSearchFilterResult
  );
  const seasonFilterApiData = useSelector(
    (state) => state?.Srt?.seasonSearchFilterResult
  );
  const srtSearchLoader = useSelector((state) => state?.Srt?.searchLoader);
  const srtSeasonData = useSelector((state) => state?.Srt?.srtSeasonSearch);
  const selectedUnselectedRows = useSelector(
    (state) => state?.Srt?.srtSelectedTableRows
  );

  const location = useLocation();
  const navigate = useNavigate();
  const [isChunkLoading, setIsChunkLoading] = useState(false);
  const [visibleCount, setVisibleCount] = useState(chunkSize);

  useEffect(() => {
  setVisibleCount(chunkSize);

  const scrollEl = containerRef?.containerRef?.containerRef?.current;

  if (scrollEl) {
      scrollEl.scrollTop = 0;
    }
  }, [current]);
  const updateQueryParams = (page, pageSize) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set("page", page);
    newQueryParams.set("pageSize", pageSize);
    navigate({ search: newQueryParams.toString() }, { replace: true });
  };

  const srtScrollPosition = localStorage.getItem("srtAutoScroll");
  // const containerRef = useRef(null);

  const activeDataSource = useMemo(() => {
    const freshLocalData = JSON.parse(localStorage.getItem("srtMassData"));
    const localData = JSON.parse(localStorage.getItem("massFilterData"));
    const hasMassFilterConditions =
      freshLocalData &&
      (freshLocalData.searchFilter ||
        freshLocalData.brandfilter ||
        freshLocalData.colorFilter ||
        freshLocalData.sizeFilter ||
        freshLocalData.statusFilter ||
        freshLocalData.vendorFilter ||
        freshLocalData.seasonFilter);

    if (hasMassFilterConditions) {
      return massFilterApiData || { results: [], count: 0 };
    }

    if (localData?.seasonFilter) {
      return srtSeasonData || { results: [], count: 0 };
    }

    return srtDataList || { results: [], count: 0 };
  }, [massFilterApiData, srtSeasonData, srtDataList]);

  const getTotalCount = () => activeDataSource?.count || 0;

  const [isPageSizeChange, setIsPageSizeChange] = useState(false);

  const onParentStyleClicked = () => {
    localStorage.setItem(
      "DashboardData",
      JSON.stringify({
        style: sockId,
        factory: vendor,
        season: season,
        brand: brand,
      })
    );
    dispatch(resetSrfSearchData([]));
    localStorage.setItem("RequestSend", false);
    dispatch(changingTabsWithCustomButton("true.2"));
    localStorage.removeItem("SrfSearchData");
    navigate("/sample-request-form");
  };

  const onSelectChange = (newSelectedRowKeys, record) => {
    const pidArray = [];
    const brandArray = record?.map((item) => {
      pidArray.push(item.BRAND[0].props.dataOfRow.style_pid);
    });
    dispatch(srtEXportArray(pidArray));
    dispatch(selectUnselectSrtTableRows(newSelectedRowKeys));
  };
  const intialSearch = useMemo(() => {
    return activeDataSource?.results || [];
  }, [activeDataSource]);
  const columns = [
    {
      title: "Style",
      dataIndex: "Style",
    },
    {
      title: "Season",
      dataIndex: "Season"
    },
    {
      title: "Vendor",
      dataIndex: "Vendor",
    },
    {
      title: "Color",
      dataIndex: "Color",
    },
    {
      title: "Size",
      dataIndex: "Size",
    },
    {
      title: "Request",
      dataIndex: "Request",
    },
    {
      title: "Promised Ex-Factory",
      dataIndex: "PromiseExFactory",
    },
    {
      title: "Date Sent/ Received",
      dataIndex: "DateSentReceived",
    },
    {
      title: "Qty.Prs. Requested/Received",
      dataIndex: "QtyPrsRequestedReceived",
    },
    {
      title: "BRAND",
      dataIndex: "BRAND",
    },
  ];

  const rowSelection = {
    selectedUnselectedRows,
    onChange: onSelectChange,
  };
  console.log("intialSearch", intialSearch);
  const data = [];
  intialSearch?.map((item, index) => {
    data.push({
      key: item?.sample_pid || `${item?.style}-${item?.color_code}-${item?.factory}-${item?.season}-${item?.size}-${index}`,
      Style: (
        <div className="srt-table-data-one">
          <p className="socks-id" onClick={onParentStyleClicked}>
            {item?.style}
          </p>
          <p className="common-font">{item?.description}</p>
        </div>
      ),
      Season: <p className="seasonDisplay">{item?.season}</p>,
      Vendor: <span className="vendor-name">{item?.factory}</span>,
      Color: <span className="socks-color">{item?.color_code}</span>,
      Size: <span className="socks-size">{item?.size}</span>,
      Request: item?.request_details?.map((data, subIndex) => {
        const requestKey = `${item?.sample_pid || item?.style}-${data?.request_no}-${subIndex}`;
        return (
          <Request
            key={`request-${requestKey}`}
            request={
              data?.is_product_ready ? (
                <span style={{ fontSize: "30px" }}>SS</span>
              ) : (
                data?.request_no
              )
            }
          />
        );
      }),
      PromiseExFactory: item?.request_details?.map((data, subIndex) => {
        const requestKey = `${item?.sample_pid || item?.style}-${data?.request_no}-${subIndex}`;
        return (
          <ExFactoryDate
            key={`exfactory-${requestKey}-${data?.promised_exfactory || "empty"}`}
            requestDate={data?.req_exfactory}
            createdDate={data.created_date}
            requestRecievedDate={data?.promised_exfactory}
            dataOfReq={data}
            itemData={item}
            salesSample="1"
            dataOfRow={item}
          />
        );
      }),
      DateSentReceived: item?.request_details?.map((data, subIndex) => {
        const requestKey = `${item?.sample_pid || item?.style}-${data?.request_no}-${subIndex}`;
        return (
          <DateSentReceive
            key={`datesent-${requestKey}-${data?.request_recieved || "empty"}-${data?.updated_date || "na"}`}
            reqNo={data?.request_no}
            createdDate={data.created_date}
            dataOfReq={data}
            recieveDate={data?.request_date}
            requestRecievedDate={data?.request_recieved}
            itemData={item}
            salesSample="1"
          />
        );
      }),
      QtyPrsRequestedReceived: item?.request_details?.map((data, subIndex) => {
        const requestKey = `${item?.sample_pid || item?.style}-${data?.request_no}-${subIndex}`;
        return (
          <QtyReqRec
            key={`qty-${requestKey}-${data?.QtyRcd ?? "empty"}-${data?.request_recieved || "empty"}-${data?.updated_date || "na"}`}
            data={data}
            user={data?.user}
            promisedDate={data?.promised_exfactory}
            requestRecievedDate={data?.request_recieved}
            qtyReciever={data?.Qty}
            qtyRecieved={data?.QtyRcd}
            commentReciever={data?.quantity_cmt}
            dataOfRow={item}
            dataOfReq={data}
            reqNo={data?.request_no}
            itemData={item}
            salesSample="1"
          />
        );
      }),
      BRAND: item?.request_details?.map((data, subIndex) => {
        const requestKey = `${item?.sample_pid || item?.style}-${data?.request_no}-${subIndex}`;
        return (
          <Brand
            key={`brand-${requestKey}-${data?.brand_status || "empty"}-${data?.updated_date || "na"}`}
            user={data?.user}
            data={data}
            brandStatus={data?.brand_status}
            statusFor="brand"
            dataOfRow={item}
            reqNo={data?.request_no}
            commentReciever={data?.brand_cmt}
            salesSample="1"
          />
        );
      }),
    });
  });

  // const handleScroll = () => {
  //   if (containerRef.current) {
  //     const scrollTop = containerRef?.current?.scrollTop;
  //     localStorage.setItem("srtAutoScroll", scrollTop);
  //   }
  // };

  useEffect(() => {
  if (!containerRef?.containerRef?.containerRef?.current) return;
  
  const scrollEl = containerRef?.containerRef?.containerRef?.current;
  console.log("scrollllllllll", scrollEl);
  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = scrollEl;

    const bottomReached =
    scrollTop + clientHeight >= scrollHeight - 5;

    if (bottomReached && visibleCount < data.length) {
      setIsChunkLoading(true);
      setTimeout(() => {
        setVisibleCount(prev =>
          Math.min(prev + chunkSize, data.length)
        );
        setIsChunkLoading(false);
      }, 400);
    }
  };

  scrollEl.addEventListener("scroll", handleScroll);

  return () =>
    scrollEl.removeEventListener("scroll", handleScroll);

}, [visibleCount, data.length, chunkSize, containerRef]);
  const handleScrollButton = () => {
    if (srtScrollPosition) {
      window.scrollTo({
        top: containerRef?.current?.offsetTop,
      });
      containerRef?.current?.scrollTo({
        top: srtScrollPosition,
      });
    }
  };

  useEffect(() => {
    handleScrollButton();
  }, [srtDataList, massFilterApiData, seasonFilterApiData, srtSeasonData]);
  const [isPageChangeTriggered, setIsPageChangeTriggered] = useState(false);

  const isChangingPageSizeRef = useRef(false);

  const onShowSizeChange = (current, pageSize) => {
    console.log("checkingonsizechange", current, pageSize);
    isChangingPageSizeRef.current = true;
    setCurrent(1);
    setPageCount(pageSize);
    updateQueryParams(1, pageSize);

    handlePaginationChange(1, pageSize);

    setTimeout(() => {
      isChangingPageSizeRef.current = false;
    }, 0);
  };

  const onChange = (page) => {
    if (isChangingPageSizeRef.current) {
      return;
    }

    setCurrent(page);
    updateQueryParams(page, pageCount);
    handlePaginationChange(page, pageCount);
  };

  useEffect(() => {
    if (isPageChangeTriggered) {
      handlePaginationChange(current, pageCount);
      updateQueryParams(current, pageCount);
      setIsPageChangeTriggered(false);
    }
  }, [isPageChangeTriggered]);

  const handlePaginationChange = useCallback(
    (current, pageCount) => {
      const freshLocalData = JSON.parse(localStorage.getItem("srtMassData"));
      const localData = JSON.parse(localStorage.getItem("massFilterData"));
      if (
        freshLocalData &&
        (freshLocalData.searchFilter ||
          freshLocalData.brandfilter ||
          freshLocalData.colorFilter ||
          freshLocalData.sizeFilter ||
          freshLocalData.statusFilter ||
          freshLocalData.vendorFilter ||
          freshLocalData?.seasonFilter)
      ) {
        dispatch(
          massSearchFilter(
            freshLocalData?.searchFilter || "",
            freshLocalData?.brandfilter || "",
            freshLocalData?.colorFilter || "",
            freshLocalData?.sizeFilter || "",
            freshLocalData?.statusFilter || "",
            freshLocalData?.vendorFilter || "",
            1,
            freshLocalData?.seasonFilter || "",
            current,
            pageCount
          )
        );
      } else if (localData && localData?.seasonFilter) {
        dispatch(
          srtSeasonSearchFilter(
            localData?.brandfilter || localData?.brand,
            localData?.seasonFilter || "",
            current,
            pageCount,
            1,
          )
        );
      } else {
        dispatch(getSrtInitialList("", "", "", "", 1, "", current, pageCount));
      }
    },
    [current, pageCount]
  );

  return (
    <div>
      {srtSearchLoader ? (
        <Loader />
      ) : null}
      <div className="srt-table">
        {intialSearch?.length === 0 ? (
          <Table
            onMouseEnter={false}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={[]}
            pagination={false}
            rowClassName={() => "row"}
          />
        ) : (
          <Table
            onMouseEnter={false}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={data.slice(0, visibleCount)}
            rowClassName={() => "row"}
            pagination={false}
          />
        )}
        {isChunkLoading && (
          <BeatLoader
            color={"#0C3D5E"}
            loading={isChunkLoading}
            cssOverride={{
              margin: "30px auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              borderColor: "#0C3D5E",
            }}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        )}
      </div>
      <Pagination
        current={current}
        onChange={onChange}
        total={getTotalCount()}
        pageSize={pageCount}
        showSizeChanger = {false}
        // onShowSizeChange={onShowSizeChange}
        style={{ textAlign: "right", marginTop: "20px" }}
      />
    </div>
  );
};

export default SalesTable;
